var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33268 13.8329V14.3329C5.46529 14.3329 5.59247 14.2802 5.68624 14.1865L5.33268 13.8329ZM2.66602 13.8329H2.16602C2.16602 14.109 2.38987 14.3329 2.66602 14.3329V13.8329ZM2.66602 11.1662L2.31246 10.8127C2.21869 10.9065 2.16602 11.0336 2.16602 11.1662H2.66602ZM10.1946 3.63764L10.5482 3.9912V3.9912L10.1946 3.63764ZM11.1374 3.63764L10.7839 3.9912V3.9912L11.1374 3.63764ZM12.8613 5.3615L13.2148 5.00795V5.00795L12.8613 5.3615ZM12.8613 6.30431L12.5077 5.95076L12.8613 6.30431ZM5.33268 13.3329H2.66602V14.3329H5.33268V13.3329ZM3.16602 13.8329V11.1662H2.16602V13.8329H3.16602ZM3.01957 11.5198L10.5482 3.9912L9.84106 3.28409L2.31246 10.8127L3.01957 11.5198ZM10.7839 3.9912L12.5077 5.71506L13.2148 5.00795L11.491 3.28409L10.7839 3.9912ZM12.5077 5.95076L4.97913 13.4794L5.68624 14.1865L13.2148 6.65786L12.5077 5.95076ZM12.5077 5.71506C12.5728 5.78014 12.5728 5.88567 12.5077 5.95076L13.2148 6.65786C13.6704 6.20225 13.6704 5.46356 13.2148 5.00795L12.5077 5.71506ZM10.5482 3.9912C10.6133 3.92611 10.7188 3.92611 10.7839 3.9912L11.491 3.28409C11.0354 2.82848 10.2967 2.82848 9.84106 3.28409L10.5482 3.9912Z",
    fill: "#024E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.83301L10.6667 8.49967",
    stroke: "#024E82",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7efc51ddd600c1a6269524b620e0773c.svg";
export { ForwardRef as ReactComponent };